import { render, staticRenderFns } from "./pindaan-d-harta_tidakalih.vue?vue&type=template&id=74b45c58&"
import script from "./pindaan-d-harta_tidakalih.vue?vue&type=script&lang=js&"
export * from "./pindaan-d-harta_tidakalih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports